import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-rotate",
  "use": "icon-rotate-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-rotate\"><path d=\"M0 0m102.4 0l819.2 0q102.4 0 102.4 102.4l0 819.2q0 102.4-102.4 102.4l-819.2 0q-102.4 0-102.4-102.4l0-819.2q0-102.4 102.4-102.4Z\" fill=\"#000000\" opacity=\".7\" /><path d=\"M256 512a255.488 255.488 0 0 1 95.1296-199.168l-66.6624 0.0512V256h199.0656v199.1168h-56.832l-0.0512-123.0336a199.168 199.168 0 1 0 227.584 40.6016V299.1104A256 256 0 1 1 256 512z\" fill=\"#FFFFFF\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol